import React from "react";
import {
  Container,
  Grid,
  ButtonBase,
  makeStyles,
  Paper,
  Typography,
} from "@material-ui/core";

import useIcon from "../hooks/useIcon";

import * as chains from "../constants/chains";

const configs = require("../configs.json");

const useStyles = makeStyles((theme) => ({
  container: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paperContainer: {
    borderRadius: theme.spacing(2),
    padding: theme.spacing(5),
    maxWidth: 500,
    margin: "auto",
    width: "100%",
  },
  fullWidth: {
    width: "100%",
  },
  title: {
    textAlign: "center",
    fontWeight: 600,
    padding: theme.spacing(0.5),
    marginBottom: theme.spacing(1),
  },
  hr: {
    width: "100%",
    color: theme.palette.grey[400],
  },
  balance: {
    padding: theme.spacing(1),
    overflow: "wrap",
    textAlign: "center",
  },
  buttonIcon: {
    marginRight: theme.spacing(1),
    padding: theme.spacing(0.4),
  },
  footer: {
    marginTop: "155px",
  },
  button: {
    width: "100%",
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    marginTop: theme.spacing(1),
    border: `2px solid ${theme.palette.background.default}`,
    backgroundColor: theme.palette.background.default,
    borderRadius: "20px",
    height: "68px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "&:hover, &$focusVisible": {
      borderColor: theme.palette.primary.main,
    },
  },
}));

function ConnectNetworkPage({ darkMode, switchNetwork }) {
  const classes = useStyles();
  const [iconImage] = useIcon();
  return (
    <Container className={classes.container}>
      <Paper elevation={0} className={classes.paperContainer}>
        <img
          src={
            darkMode && configs.theme.logo.smallLogoLight
              ? configs.theme.logo.smallLogoLight
              : configs.theme.logo.smallLogo
          }
          alt="logo"
          className="d-block m-auto mb-4 big-simple-logo"
        />
        <Typography variant="h5" className={classes.title}>
          Choose Network
        </Typography>

        <Grid container direction="column">
          {Object.values(chains.chainConfigs).map((value, index) => (
            <Grid item key={index} xs={12}>
              <ButtonBase
                focusRipple
                className={classes.button}
                onClick={() => switchNetwork(value)}
              >
                <img
                  src={iconImage(value.nativeCurrency.name)}
                  alt={value.nativeCurrency.name}
                  className={classes.coinImage}
                />

                <div className={classes.coinBox}>
                  <Typography variant="body1">{value.chainName}</Typography>
                </div>
              </ButtonBase>
            </Grid>
          ))}
        </Grid>
      </Paper>
    </Container>
  );
}

export default ConnectNetworkPage;
